import { memo } from "react";
import { ReclaimInstallAppPromptHost } from "./reclaim-install-app-modal/reclaim-install-app-prompt-host";

export const MerchantPromptHost = memo(function MerchantPromptHost() {
  return <ReclaimInstallAppPromptHost />;
});
